import { render } from "./Ophthalmology.vue?vue&type=template&id=1721ad29&scoped=true"
import script from "./Ophthalmology.vue?vue&type=script&lang=ts"
export * from "./Ophthalmology.vue?vue&type=script&lang=ts"

import "./Ophthalmology.vue?vue&type=style&index=0&id=1721ad29&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1721ad29"

export default script